import {
    Table,
    TableColumn,
    TableRow,
    TableHeaderTheme,
    TableRowTheme,
    TableBorderRadius,
    TableBorderStyle,
    TableRowSeperatorStyle,
} from '@apply/components';
import { UserExperienceDto } from '@apply/api/src/api/ApplyApi';
import { formatExperienceAddressWithStatus } from '../../../constants/formatExperienceAddressWithStatus';
import { VerificationStatusIconCell } from '../../../components/cells/VerificationStatusIconCell';
import { ExperienceVerificationStatusType } from '@apply/constants';
import { formatProjectType } from '../../../constants/formatProjectType';
import { formatExperienceStatus } from '../../../constants/formatExperienceStatus';
import { ActionsCell } from './components/cells/ActionsCell/ActionsCell';
import { isMobileScreen } from '@apply/ui';

export interface UnverifiedTableProps {
    experiences: UserExperienceDto[];
}

export const UnverifiedTable: React.FC<UnverifiedTableProps> = ({ experiences }) => {
    const mobileScreen = isMobileScreen();
    const renderExperienceStatusIcon = (verificationStatusType: ExperienceVerificationStatusType) => {
        return <VerificationStatusIconCell experienceStatusTypeId={verificationStatusType} />;
    };

    const renderUnverifiedActions = (experienceId: number, experienceTypeId: number, isVerified: boolean) => {
        return (
            <ActionsCell
                experienceId={experienceId}
                experienceTypeId={experienceTypeId}
                isVerified={isVerified}
            />
        );
    };

    const data = experiences.map<TableRow>((experience) => ({
        experienceStatusIcon: renderExperienceStatusIcon(experience.verificationStatusTypeId),
        verificationStatus: formatExperienceStatus(experience.verificationStatusTypeId),
        propertyAddress: formatExperienceAddressWithStatus(experience),
        projectType: formatProjectType(experience.projectTypeId),
        actions: renderUnverifiedActions(experience.id, experience.experienceTypeId, experience.isVerified),
        rowColor: [ExperienceVerificationStatusType.Rejected, ExperienceVerificationStatusType.UnableToVerify].includes(
            experience.verificationStatusTypeId
        )
            ? '#FFF1F1'
            : undefined,
    }));

    return (
        <>
            {mobileScreen && (
                <>
                    <br />
                    <h3>Unverified Experience</h3>
                    <br />
                </>
            )}
            <Table
                headerTheme={TableHeaderTheme.Gray}
                rowTheme={TableRowTheme.Gray}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                rowSeperatorStyle={TableRowSeperatorStyle.Medium}
                showHeader={true}
                data={data}
                width='100%'
                enablePaging={true}
                minimumHeaderHeight={50}
                minimumRowHeight={50}
                emptyTableText='No Properties Provided'
                emptyTableTextAlign='left'
            >
                <TableColumn
                    columnKey='experienceStatusIcon'
                    width='5%'
                    visible={!mobileScreen}
                    center={true}
                />
                <TableColumn
                    columnKey='verificationStatus'
                    width='15%'
                    header='Status'
                />
                <TableColumn
                    columnKey='projectType'
                    width='20%'
                    visible={true}
                    header='Project Type'
                />
                <TableColumn
                    columnKey='propertyAddress'
                    header='Address'
                    width='50%'
                    visible={true}
                />
                <TableColumn
                    columnKey='actions'
                    header=''
                    width='10%'
                    visible={true}
                />
            </Table>
        </>
    );
};
